export default __webpack_public_path__ + "static/media/divider.1e80e1f9.png";